// Shared site data — Amcblast Solutions Limited
export const SITE = {
  brand: "Amcblast Solutions Limited",
  short: "Amcblast",
  tagline: "We set the pace.",
  company: "Amcblast Solutions Limited",
  rc: "RC: 943327",
  yearStarted: 2009,
  yearIncorporated: 2011,
  logo:
    "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/zoouqbbg_logo.png",
  favicon:
    "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/0rjvnjud_favicon.png",
  profilePdf: "https://amcblastsolutions.com/Amcblast_Company_Profile_2026_2027.pdf",
  phone: "+234 803 954 7692",
  email: "info@amcblastsolutions.com",
  website: "www.amcblastsolutions.com",
  offices: [
    { label: "Head Office", line: "Old Ojo Road, Maza Maza, Lagos, Nigeria" },
    { label: "Home of Automation", line: "Ikota Shopping Complex, KM 22 Lagos-Epe Expressway" },
    { label: "United Kingdom", line: "Cardiff, United Kingdom" },
  ],
  address: "Old Ojo Road, Maza Maza, Lagos, Nigeria",
};

// Sectors Amcblast has built software for
export const SECTORS = [
  "Transport",
  "Oil & Gas",
  "Banking",
  "Education",
  "Petroleum Depot",
  "LPG",
  "Properties / Real Estate",
  "Procurement",
  "Fintech",
  "Consultancy",
  "Healthcare",
  "Hospitality",
  "Retail / POS",
  "Logistics",
  "Government",
  "Laboratory / Diagnostics",
  "Manufacturing",
  "Telecoms",
];

// Big-screen hero slider
export const HERO_SLIDES = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/6plfoy4e_image.png",
    eyebrow: "Custom Software Engineering",
    title: "Code that compounds your competitive edge.",
    subtitle:
      "Production-grade applications crafted in agile sprints — designed for scale, security and the realities of the African market.",
    cta: { label: "Start a Project", to: "/contact?type=quote" },
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/cvf9lbzm_image.png",
    eyebrow: "Enterprise Systems & SAP",
    title: "Connect every system. Unlock every insight.",
    subtitle:
      "From SAP integrations and ERP rollouts to bespoke dashboards — we turn fragmented data into one source of truth.",
    cta: { label: "Explore Solutions", to: "/solutions" },
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/q2tq4dcb_image.png",
    eyebrow: "API & Platform Integrations",
    title: "Where APIs meet outcomes.",
    subtitle:
      "Banking alerts, payment gateways, telco SMS, fintech rails — we plug everything in so your platform just works.",
    cta: { label: "See Our Work", to: "/profile" },
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_startup-showcase-43/artifacts/qf6tqizh_image.png",
    eyebrow: "AI-Powered Experiences",
    title: "Smarter products. Calmer operations.",
    subtitle:
      "Chatbots, predictive analytics and AI-augmented workflows that genuinely move the numbers that matter.",
    cta: { label: "Talk to AmcBot", to: "/faq" },
  },
];

export const HERO = {
  illustration:
    "https://static.prod-images.emergentagent.com/jobs/97849be4-c6d0-4496-9320-d828088b3924/images/104735acdb649d33bc7ac3c017289817499258b50e47c5a27b0575980718e835.png",
  roadmap_bg:
    "https://static.prod-images.emergentagent.com/jobs/97849be4-c6d0-4496-9320-d828088b3924/images/d625015879bad8f0e4e52c48e46f0622def6eff831b3ba14c539321e6cd24cd2.png",
  feature_graphic:
    "https://static.prod-images.emergentagent.com/jobs/97849be4-c6d0-4496-9320-d828088b3924/images/c751874b803f9a431cf7322cd4377f90f84c0f0ebf1a99b8e2f10d75c3bdc8de.png",
};

// Technology stack / tools partners (marquee on home page)
export const PARTNERS = [
  "Anthropic Claude",
  "Scale AI",
  "Linear",
  "SonarQube",
  "Datadog",
  "CrowdStrike",
  "Cloudflare",
  "Wiz",
  "AWS Bedrock",
  "Microsoft Azure",
  "CoreWeave",
  "Figma",
  "Notion",
  "OpenAI API",
  "Mixpanel",
  "Kubernetes",
  "GitHub",
  "CymorthAI",
];

// Full services catalogue (16)
export const SERVICES = [
  {
    slug: "web-design",
    title: "Web Design",
    short:
      "Corporate websites, portals and landing pages that clearly present your brand and capture the leads you need.",
    color: "pink",
    bg: "bg-[#FCE7F3]",
    icon: "Layout",
    deliverables: [
      "Brand-aligned UI/UX and visual identity",
      "Responsive HTML / Bootstrap 5 builds",
      "CMS integration (WordPress, headless)",
      "SEO foundations and Core Web Vitals tuning",
    ],
  },
  {
    slug: "software-development",
    title: "Software Development",
    short:
      "Custom, simplified software solutions tailored to the way your business actually operates.",
    color: "purple",
    bg: "bg-[#F3E8FF]",
    icon: "Code",
    deliverables: [
      "Discovery, architecture & technical due-diligence",
      "Agile delivery in two-week sprints with weekly demos",
      "Cloud-native deployment and CI/CD pipelines",
      "Post-launch hyper-care and continuous improvement",
    ],
  },
  {
    slug: "mobile-app-development",
    title: "Mobile App Creation",
    short:
      "iOS and Android applications engineered for real users in real network conditions across Africa and beyond.",
    color: "blue",
    bg: "bg-[#DBEAFE]",
    icon: "Smartphone",
    deliverables: [
      "Native iOS / Android and React Native / Flutter builds",
      "Push notifications, offline-first sync, payments",
      "App Store and Play Store submission management",
      "Crash analytics and performance monitoring",
    ],
  },
  {
    slug: "consultancy",
    title: "Technology Consultancy",
    short:
      "Independent, vendor-neutral advice on what to build, which tools to choose and how to phase your digital roadmap.",
    color: "green",
    bg: "bg-[#DCFCE7]",
    icon: "Compass",
    deliverables: [
      "Digital strategy and capability audits",
      "Solution architecture and vendor evaluation",
      "Phased technology roadmap with budget guidance",
      "Executive workshops and board briefings",
    ],
  },
  {
    slug: "training",
    title: "Corporate Training",
    short:
      "Practical technology training that equips individuals and teams to use modern tools confidently.",
    color: "yellow",
    bg: "bg-[#FEF9C3]",
    icon: "GraduationCap",
    deliverables: [
      "Cloud, DevOps and security curricula",
      "Hands-on labs and real-world scenarios",
      "Custom in-house cohorts for teams of 5–50",
      "Certificates of completion on assessed tracks",
    ],
  },
  {
    slug: "bulksms-solution",
    title: "BulkSMS Solution",
    short:
      "Reliable messaging platforms and integrations for alerts, reminders and marketing campaigns at scale.",
    color: "pink",
    bg: "bg-[#FCE7F3]",
    icon: "MessageSquare",
    deliverables: [
      "Sender-ID provisioning across Nigerian networks",
      "API & dashboard for one-off and scheduled blasts",
      "Two-way SMS, OTP and short-code support",
      "Delivery reporting and audit trails",
    ],
  },
  {
    slug: "payment-gateway-integration",
    title: "Payment Gateway Integration",
    short:
      "Connect your applications to secure payment gateways and streamline revenue collection.",
    color: "purple",
    bg: "bg-[#F3E8FF]",
    icon: "CreditCard",
    deliverables: [
      "Paystack, Flutterwave, Remita, Stripe & PayPal",
      "Tokenised cards, recurring billing and refunds",
      "PCI-aware integration patterns",
      "Reconciliation and revenue dashboards",
    ],
  },
  {
    slug: "site-template-sale",
    title: "Site Template Sale",
    short:
      "Professionally designed templates for fast, budget-friendly website launches.",
    color: "blue",
    bg: "bg-[#DBEAFE]",
    icon: "LayoutTemplate",
    deliverables: [
      "Curated library of industry-ready templates",
      "One-time licensing and brand customisation",
      "Domain, hosting and SSL set-up",
      "Editor training for non-technical teams",
    ],
  },
  {
    slug: "cac-registration",
    title: "Company Registration with CAC",
    short:
      "Smooth company registration support so you can start operating legally and confidently.",
    color: "green",
    bg: "bg-[#DCFCE7]",
    icon: "FileBadge",
    deliverables: [
      "Name reservation and availability search",
      "Incorporation documents and CAC filing",
      "Tax ID (TIN) and statutory registrations",
      "Post-incorporation compliance advisory",
    ],
  },
  {
    slug: "home-automation-cctv",
    title: "Home Automation & CCTV",
    short:
      "Smart, secure and connected homes and offices that you can monitor from your devices, anywhere.",
    color: "yellow",
    bg: "bg-[#FEF9C3]",
    icon: "Cctv",
    deliverables: [
      "Hikvision / Dahua IP camera installation",
      "Smart lighting, locks, thermostats and intercoms",
      "Cloud and on-prem video recording",
      "Mobile monitoring apps for owners and admins",
    ],
  },
  {
    slug: "owasp-security-testing",
    title: "OWASP Software Security Testing",
    short:
      "Penetration testing and code review aligned to the OWASP Top 10 and ASVS to keep your applications safe.",
    color: "pink",
    bg: "bg-[#FCE7F3]",
    icon: "ShieldCheck",
    deliverables: [
      "OWASP Top 10 and ASVS-level assessments",
      "Authenticated and unauthenticated penetration tests",
      "Secure-code review with prioritised remediation plan",
      "Re-test, attestation report and developer training",
    ],
  },
  {
    slug: "it-infrastructure-procurement",
    title: "IT Infrastructure Procurement",
    short:
      "End-to-end sourcing of servers, networking, power and end-user devices from globally trusted brands.",
    color: "purple",
    bg: "bg-[#F3E8FF]",
    icon: "PackageSearch",
    deliverables: [
      "Authorised supply of Dell, HP, APC, Cisco, Fortinet, etc.",
      "BOM design, RFQ management and import logistics",
      "Configuration, deployment and asset tagging",
      "Warranty and lifecycle management",
    ],
  },
  {
    slug: "structured-cabling",
    title: "Structured Cabling & Networks",
    short:
      "Copper and fibre cabling installations engineered to ANSI, TIA/EIA and ISO standards for gigabit-grade performance.",
    color: "blue",
    bg: "bg-[#DBEAFE]",
    icon: "Cable",
    deliverables: [
      "CAT5E / CAT6 / CAT6A / CAT7 and single/multi-mode fibre",
      "Network cabinets, racks and patch-panel terminations",
      "MPLS, VPN, managed switching and Wi-Fi",
      "Certified testing and as-built documentation",
    ],
  },
  {
    slug: "data-center-solutions",
    title: "Data Center & Server Deployment",
    short:
      "Secure, reliable and efficient data centres — from concept through commissioning and ongoing operations.",
    color: "green",
    bg: "bg-[#DCFCE7]",
    icon: "Server",
    deliverables: [
      "Site survey, capacity planning and rack layout",
      "HVAC, raised flooring, fire-suppression and access control",
      "Server and storage rack integration (Dell, HP, IBM)",
      "Monitoring, SLAs and 24×7 support",
    ],
  },
  {
    slug: "it-power-solutions",
    title: "IT Power Solutions",
    short:
      "APC Schneider Premier Partner delivering UPS, surge protection and clean-power solutions from home to data centre.",
    color: "yellow",
    bg: "bg-[#FEF9C3]",
    icon: "BatteryCharging",
    deliverables: [
      "Sizing and supply of APC / Schneider UPS systems",
      "On-site installation, commissioning and SLAs",
      "Battery replacements and preventive maintenance",
      "Authorised warranty and after-sales service",
    ],
  },
  {
    slug: "project-management",
    title: "Project Management & Consulting",
    short:
      "PMI- and ITIL-aligned delivery to keep your projects on time, on budget and aligned to business outcomes.",
    color: "pink",
    bg: "bg-[#FCE7F3]",
    icon: "ListChecks",
    deliverables: [
      "Stakeholder discovery and needs assessment",
      "Detailed project plan, RAID log and governance",
      "Vendor management and progress reporting",
      "Hand-over, training and benefits realisation",
    ],
  },
];

export const ROADMAP_STEPS = [
  { step: "01", title: "Discover & Assess", desc: "Stakeholder interviews, site survey, and current-state audit." },
  { step: "02", title: "Design & Architect", desc: "Solution design, BOM, and clear delivery plan." },
  { step: "03", title: "Build & Configure", desc: "Develop, integrate and configure to industry standards." },
  { step: "04", title: "Test & Certify", desc: "QA, OWASP-aligned security and certified line testing." },
  { step: "05", title: "Deploy & Train", desc: "Cut-over, knowledge transfer and user enablement." },
  { step: "06", title: "Operate & Improve", desc: "SLAs, monitoring and continuous improvement." },
];

export const TESTIMONIALS = [
  {
    name: "Dr. Adaobi Okeke",
    role: "Operations Director, Paramount Medical Services",
    quote:
      "Amcblast rebuilt our patient management platform and migrated us to a resilient cloud setup. Downtime dropped to near-zero and our staff genuinely enjoy using the tools.",
  },
  {
    name: "Tunde Adebayo",
    role: "Head of IT, Rockview Hotels Ltd",
    quote:
      "From structured cabling to the booking platform, Amcblast delivered a complete IT refresh across three properties — on schedule and inside budget.",
  },
  {
    name: "Chioma Eze",
    role: "Registrar, Funbis International School",
    quote:
      "Their team automated our admissions, results and library systems. Parents now self-serve and our administrative load is a fraction of what it used to be.",
  },
  {
    name: "Emeka Nwankwo",
    role: "CIO, Young Shall Grow Transport",
    quote:
      "Amcblast built our fleet, ticketing and depot-management stack from scratch. We now process 30,000+ tickets a week with zero double-bookings.",
  },
  {
    name: "Funmi Adelaja",
    role: "Compliance Lead, Oparamou Microfinance",
    quote:
      "They integrated us with GTBank and FBN alert rails in record time, and their OWASP testing surfaced two issues we'd have missed. Highly recommend.",
  },
  {
    name: "Engr. Babatunde Sanni",
    role: "Plant Manager, NLNG-aligned LPG Depot",
    quote:
      "Tank gauging, dispatch and reconciliation — all on one platform. Audits that used to take a week now take three hours.",
  },
  {
    name: "Kemi Bankole",
    role: "Head, Procurement, FinICT Hubs",
    quote:
      "Their procurement portal cut our PO cycle time from 11 days to 36 hours. Vendors love the self-service module.",
  },
  {
    name: "Pastor John Olu",
    role: "Director, Johngbor Foundation",
    quote:
      "From a simple donations site to a full membership platform — the journey with Amcblast has been a partnership, not a transaction.",
  },
];

export const CLIENTS = {
  Healthcare: ["Paramount Medical & Pharmaceutical Services", "NGPMPS Pharmaceutical Services"],
  Education: [
    "Nigerian Army Qualification Examination",
    "Johngbor Foundation",
    "Funbis International School",
    "Lagos State Polytechnic — Online Library",
    "Lagos State University",
    "IMS Computer School",
    "Star Systems Computer School",
    "Giwat Web Creation & Training Centre",
    "Molad International School",
  ],
  "Finance": [
    "Oparamou Microfinance",
    "GTBank Alert Integration",
    "FBN Alert Integration",
  ],
  "Real Estate": [
    "Young Shall Grow Properties",
    "Brickwall Global",
    "A.O. Williams Planning & Consultants (UK)",
    "A.O. Williams Planning & Consultants (Nigeria)",
    "De Prestige Housing",
    "Fin ICT Hubs Limited",
  ],
  "Hospitality": ["Rockview Hotels Ltd", "Prestige Lounge"],
  "General Business": ["Apacino Limited", "Return Over Investment Co. Ltd (Ghana)"],
};

export const VALUES = [
  { t: "Integrity", d: "Honesty and transparency in every brief, proposal and invoice." },
  { t: "Excellence", d: "Consistency and quality through standardisation and senior craft." },
  { t: "Partnership", d: "We win when you win — a long-term, relationship-first posture." },
  { t: "Performance", d: "A passion for winning and the discipline to deliver outcomes." },
];

export const BLOG_POSTS = [
  {
    slug: "10-best-ai-apps-android",
    title: "10 Best AI Apps for Android to Make Life Easier",
    excerpt:
      "From scheduling to learning, these AI-native apps are reshaping how we use our phones every day.",
    date: "Dec 02, 2025",
    author: "Chinedu Okafor",
    thumb:
      "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3Nzg3ODkzMDJ8MA&ixlib=rb-4.1.0&q=85",
    category: "Mobile",
  },
  {
    slug: "ship-faster-with-design-systems",
    title: "Ship Faster With a Lightweight Design System",
    excerpt:
      "Design systems aren't just for Fortune 500s. Here's how a 4-person team can adopt one in two weeks.",
    date: "Nov 24, 2025",
    author: "Folake Ade",
    thumb:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3Nzg3ODkzMDJ8MA&ixlib=rb-4.1.0&q=85",
    category: "Design",
  },
  {
    slug: "cloud-cost-playbook-2026",
    title: "The 2026 Cloud Cost Playbook for Nigerian Startups",
    excerpt:
      "Stop overspending. Seven proven levers to cut AWS, GCP, and Azure bills without sacrificing performance.",
    date: "Nov 11, 2025",
    author: "Kingsley Obi",
    thumb:
      "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwc3RhcnR1cCUyMG9mZmljZXxlbnwwfHx8fDE3Nzg3ODkzMDJ8MA&ixlib=rb-4.1.0&q=85",
    category: "Cloud",
  },
];

export const FAQS = [
  {
    q: "What kind of clients do you typically serve?",
    a: "We work with healthcare, education, finance, hospitality, real estate and public-sector clients across Nigeria, with an additional presence in the UK.",
  },
  {
    q: "How long does a typical engagement take?",
    a: "Most engagements run 8–16 weeks. We share a detailed roadmap, BOM and timeline after a 1-hour discovery call.",
  },
  {
    q: "Do you sign NDAs?",
    a: "Yes. We routinely sign mutual NDAs before any commercially sensitive discussion.",
  },
  {
    q: "Which technologies do you specialise in?",
    a: "Web (React, Next.js, WordPress), software (Node, Python, FastAPI, .NET), mobile (React Native, Flutter), cloud (AWS, GCP, Azure), networks (Cisco, Aruba, Fortinet) and power (APC Schneider).",
  },
  {
    q: "Can you procure and install hardware as well?",
    a: "Yes — we are an authorised partner for Dell, APC Schneider, Fortinet, Kaspersky, IBM and Hikvision, and we deliver turn-key installations.",
  },
  {
    q: "Do you provide support after launch?",
    a: "Yes — every project includes a hyper-care period and optional SLAs for ongoing managed support.",
  },
];

export const PRICING = [
  {
    name: "Essentials",
    price: "₦450k",
    period: "/ project",
    desc: "For startups and SMEs needing a focused, fast launch.",
    features: [
      "Brochure-grade website or single workflow build",
      "Up to 6 pages or 1 core module",
      "1 round of revisions",
      "Email & WhatsApp support",
    ],
    highlight: false,
  },
  {
    name: "Growth",
    price: "₦2.5m+",
    period: "/ engagement",
    desc: "The sweet spot for mid-sized businesses transforming operations.",
    features: [
      "Full pod (PM + 2 devs + designer + QA)",
      "Custom software or full IT infrastructure rollout",
      "Cloud / on-prem deployment & training",
      "Priority support, 5×8 SLA",
    ],
    highlight: true,
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    desc: "Mission-critical platforms with dedicated SLAs and on-prem capabilities.",
    features: [
      "Multi-pod delivery and on-site teams",
      "Architecture, security and compliance reviews",
      "24×7 monitoring and on-call",
      "Quarterly business reviews",
    ],
    highlight: false,
  },
];
